import { render, staticRenderFns } from "./SurfInlineSingleTextPlain.vue?vue&type=template&id=98685548&scoped=true"
import script from "./SurfInlineSingleTextPlain.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfInlineSingleTextPlain.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SurfInlineSingleTextPlain.vue?vue&type=style&index=0&id=98685548&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98685548",
  null
  
)

export default component.exports